import { useEffect, useState } from 'react';
import { Moon, X, Receipt, Clock } from 'lucide-react';
import { http, money } from '../lib/api';

const todayIso = () => new Date().toISOString().slice(0, 10);
const dismissedKey = (k, v) => localStorage.getItem(k) === v;

export function EveningReminder({ page, onGo, refreshKey, hour = 18 }) {
  const [stats, setStats] = useState(null);
  const [dayHidden, setDayHidden] = useState(() => dismissedKey('sales-reminder-dismissed', todayIso()));
  const [monthHidden, setMonthHidden] = useState(false);
  const [missing, setMissing] = useState([]); const [staffHidden, setStaffHidden] = useState(() => dismissedKey('staff-reminder-dismissed', todayIso()));
  useEffect(() => { http.get('/alerts', { params: { days: 0 } }).then(r => setMissing(r.data.staff_missing || [])).catch(() => {}); }, [refreshKey]);
  useEffect(() => { http.get('/sales/stats').then(r => { setStats(r.data); setMonthHidden(dismissedKey('commission-reminder-dismissed', r.data.cur_month)); }).catch(() => {}); }, [refreshKey]);
  const showStaff = missing.length > 0 && !staffHidden && new Date().getHours() >= hour && page !== 'staff';
  const hideStaff = () => { localStorage.setItem('staff-reminder-dismissed', todayIso()); setStaffHidden(true); };
  const goQuick = () => { sessionStorage.setItem('open-quick-day', '1'); onGo('staff'); };
  if (!stats || page === 'sales') return showStaff ? <StaffBanner missing={missing} onGo={goQuick} onHide={hideStaff} /> : null;
  const showDay = !stats.has_today && !dayHidden && new Date().getHours() >= hour;
  const prevBooked = stats.pos_booked?.[stats.prev_month] || [];
  const pending = (stats.pos || []).filter(p => p.prev_commission > 0 && !prevBooked.includes(p.id));
  const pendingTotal = pending.reduce((a, p) => a + p.prev_commission, 0);
  const showMonth = new Date().getDate() <= 7 && pending.length > 0 && !monthHidden;
  const hideDay = () => { localStorage.setItem('sales-reminder-dismissed', todayIso()); setDayHidden(true); };
  const hideMonth = () => { localStorage.setItem('commission-reminder-dismissed', stats.cur_month); setMonthHidden(true); };
  const goBook = () => { sessionStorage.setItem('open-commission-book', '1'); onGo('sales'); };
  return <>
    {showMonth && <div className="evening-reminder month" data-testid="commission-reminder">
      <Receipt size={16} />
      <p><strong>{stats.prev_month_label} ayı kapandı.</strong> Geçen ayın POS komisyonlarını ({money(pendingTotal)}) tek tıkla gider olarak kaydedebilirsiniz.</p>
      <button type="button" className="primary-btn small" onClick={goBook} data-testid="commission-reminder-go">Gider yaz</button>
      <button type="button" className="icon-btn" onClick={hideMonth} aria-label="Bu ay hatırlatma" data-testid="commission-reminder-dismiss"><X size={14} /></button>
    </div>}
    {showStaff && <StaffBanner missing={missing} onGo={goQuick} onHide={hideStaff} />}
    {showDay && <div className="evening-reminder" data-testid="evening-reminder">
      <Moon size={16} />
      <p><strong>Bugünün cirosu henüz girilmedi.</strong> Kasayı kapatırken günün toplamını birkaç saniyede kaydedebilirsiniz.</p>
      <button type="button" className="primary-btn small" onClick={() => onGo('sales')} data-testid="evening-reminder-go">Ciro gir</button>
      <button type="button" className="icon-btn" onClick={hideDay} aria-label="Bugün hatırlatma" data-testid="evening-reminder-dismiss"><X size={14} /></button>
    </div>}
  </>;
}

function StaffBanner({ missing, onGo, onHide }) {
  return <div className="evening-reminder staff" data-testid="staff-reminder">
    <Clock size={16} />
    <p><strong>Bugün {missing.length} personelin saati girilmedi:</strong> {missing.map(s => s.name).join(', ')}.</p>
    <button type="button" className="primary-btn small" onClick={onGo} data-testid="staff-reminder-go">Hızlı giriş</button>
    <button type="button" className="icon-btn" onClick={onHide} aria-label="Bugün hatırlatma" data-testid="staff-reminder-dismiss"><X size={14} /></button>
  </div>;
}
